export interface BadgeProps {
  variant: 'info' | 'success' | 'warning' | 'error' | 'not-started' | 'awaiting-input' | 'working' | 'complete';
  size?: 'sm' | 'md';
  children: React.ReactNode;
  className?: string;
}

export function Badge({ children, variant, size = 'md', className = '' }: BadgeProps) {
  let variantClass = '';
  if (variant === 'info') {
    variantClass = 'bg-sd-info/20 text-sd-info border border-sd-info/30';
  } else if (variant === 'success') {
    variantClass = 'bg-sd-success/20 text-sd-success border border-sd-success/30';
  } else if (variant === 'warning') {
    variantClass = 'bg-sd-warning/20 text-sd-warning border border-sd-warning/30';
  } else if (variant === 'error') {
    variantClass = 'bg-sd-error/20 text-sd-error border border-sd-error/30';
  } else if (variant === 'not-started') {
    variantClass = 'bg-sd-border/30 text-sd-text-secondary border border-sd-border/50';
  } else if (variant === 'awaiting-input') {
    variantClass = 'bg-sd-warning/20 text-sd-warning border border-sd-warning/30';
  } else if (variant === 'working') {
    variantClass = 'bg-sd-info/20 text-sd-info border border-sd-info/30';
  } else if (variant === 'complete') {
    variantClass = 'bg-sd-success/20 text-sd-success border border-sd-success/30';
  }
  const sizeClass = size === 'md' ? 'text-sm px-2 py-0.5' : 'text-xs px-1.5 py-0.5';
  const ariaLabel = typeof children === 'string' ? children : undefined;
  return <span className={`${variantClass} ${sizeClass} font-semibold rounded-sd-sm ${className}`.trim()} aria-label={ariaLabel}>{children}</span>;
}
